import { getDateTime, } from "@bracket/parlance";
import type { ISOTimeString, Nav, } from "@bracket/types";


// export const getEpochForDay = ( vault: IVaultNavHistory, day_num: number, ): Nav["epoch"] => {

// 	const { navs, epoch_duration_days, epoch_offset_hours, launch_date, } = vault;
// 	const sorted_navs = navs.sort((a, b) => a.epoch - b.epoch);

// 	for(let i = 0; i < sorted_navs.length; i++) {
// 		const nav = sorted_navs[i];
// 		const { epoch, } = nav;
// 		const epoch_start_day = DateTime.fromISO(launch_date).plus({ days: nav.epoch * epoch_duration_days, hours: epoch_offset_hours, }).diffNow("days").days * -1;
// 		const epoch_end_day = epoch_start_day + epoch_duration_days;
// 		if(day_num >= epoch_start_day && day_num <= epoch_end_day) {
// 			return epoch;
// 		}
// 		throw new Error(`Nav not found for day ${day_num} and epoch ${epoch}`);
// 	}
// 	return -1;
// }

export declare type IVaultEpochConfig = {
	epoch_duration_days: number;
	launch_date: ISOTimeString;
	epoch_offset_hours: number;
};

export const getExpectedEpochForDay = ( vault: IVaultEpochConfig, day_num: number, ): Nav["epoch"] | null => {
	const { epoch_duration_days, launch_date, epoch_offset_hours, } = vault;
	const launchDate = getDateTime(launch_date).plus({ days: epoch_offset_hours / 24, }); // use days for DateTime to handle DST
	const dayDate = launchDate.plus({ days: day_num, });
	const dayDiff = dayDate.diff(launchDate, "days").days;
	// Epochs are 1-indexed: day 0 = epoch 1, day 1 = epoch 2 (if epoch_duration_days = 1), etc.
	return Math.floor(dayDiff / epoch_duration_days) + 1;
}

